module.exports = __webpack_public_path__ + "common/icon-arrow-right-878b96193670d601f5dbca1702b6e2d2.svg";